module.exports = __webpack_public_path__ + "static/WIIBPhone1-bb635f400c6cfe73ac64d1c0b6dade07.svg";